import { createContext } from 'react';

export const FormStepContext = createContext(null);
